import {Component, OnDestroy, OnInit} from '@angular/core';
import {UserRulesService} from "./user-rules.service";
import {Subscription} from "rxjs";

@Component({
  selector: 'pbc-user-rules',
  templateUrl: './user-rules.component.html'
})
export class UserRulesComponent implements OnInit, OnDestroy {

  showUserRules : boolean = false;
  private subscription: Subscription;

  constructor(
    private userRulesService : UserRulesService,
  ) { }

  ngOnInit() {
    this.subscription = this.userRulesService.showUserRules.subscribe((show : boolean) => {
      this.showUserRules = show;
    })
  }

  ngOnDestroy(): void {
    this.subscription = null;
  }

  closeUserRulesClick() {
    this.showUserRules = false;
  }

}
